import demandsAPI from '.'
import qs from 'qs'

export async function getDemands({ page, limit, search = '', ...filters }) {
	const { data } = await demandsAPI.get(`/tasks/list`, {
		params: {
			page,
			limit,
			search,
			...filters,
		},
	})

	return data
}

const formatOptions = (list) => {
	if (!Array.isArray(list)) return []
	return list.map((item) => ({
		label: item.name,
		value: item.id,
	}))
}

export async function getCategoriesOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/categories?search=${search}`)
	return formatOptions(data.list)
}

export async function getTemplatesOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/templates?search=${search}`)
	return formatOptions(data.list)
}

export async function getUsersOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/users?search=${search}`)
	return formatOptions(data.list)
}

export async function getSolicitantAreasOptions(search = '') {
	const query = typeof search === 'string' ? search : ''
	const { data } = await demandsAPI.get(
		`/filters/solicitant-areas?search=${search}`
	)
	const list = data.list || []
	return list.map((item) => ({
		label: item.name,
		value: item.id,
		managementTeamId: item.management_team_id,
		onlyManagement: item.only_management,
	}))
}

export async function updateStatus({ id, status }) {
	const { data } = await demandsAPI.post(`/tasks/update-status`, {
		taskId: id,
		status,
	})

	return data
}

export async function listResponsibles(
	page = 1,
	limit = 10,
	search,
	teamId = ''
) {
	const { data } = await demandsAPI.get('/users/list', {
		params: { page, limit, search, teamId },
	})

	return data
}

export async function setResponsible({ taskId, userId }) {
	const { data } = await demandsAPI.post('/tasks/claim-ownership', {
		taskId,
		userId,
	})

	return data
}

export async function getOptions({ route, page = 1, limit = 10 }) {
	const { data } = await demandsAPI.get(`${route}?page=${page}&limit=${limit}`)

	return data
}

export async function createDemand(payload) {
	try {
		const response = await demandsAPI.put('/tasks/create', payload)

		if (!response) {
			throw new Error('A API não retornou uma resposta válida.')
		}

		return response.data
	} catch (error) {
		console.error('Erro ao criar demanda:', error)
		throw error
	}
}

export async function updateDemand(payload) {
	const { data } = await demandsAPI.post('/tasks/update', payload)

	return data
}

export async function createWorkflow(payload) {
	const { data } = await demandsAPI.put('/workflow/create', payload)

	return data
}

export async function getDemandById(id) {
	if (!id) {
		return null
	}

	try {
		const response = await demandsAPI.get(`/tasks/${id}`)
		return response.data
	} catch (error) {
		console.error(`Erro ao buscar demanda com ID ${id}:`, error)
		throw error
	}
}

export async function getDemandWorkflowById(id) {
	if (!id) {
		return null
	}

	try {
		const response = await demandsAPI.get(`/workflow/${id}`)
		return response.data
	} catch (error) {
		console.error(`Erro ao buscar workflow de demanda com ID ${id}:`, error)
		throw error
	}
}

export async function getDemandHistoryById(id) {
	if (!id) {
		return null
	}

	try {
		const response = await demandsAPI.get(`workflow/history/${id}`)
		return response.data
	} catch (error) {
		console.error(`Erro ao buscar histórico de demanda com ID ${id}:`, error)
		throw error
	}
}

export async function listMessages(taskId, skip = 0) {
	return await demandsAPI.get(`/tasks/messages/${taskId}/${skip}`)
}

export async function createMessage(taskId, formData) {
	const { data } = await demandsAPI.post(
		`/tasks/messages/create/${taskId}`,
		formData
	)

	return data
}

export async function getTaskAttachments(taskId) {
	const { data } = await demandsAPI.get(`/tasks/list-attachments/${taskId}`)

	return data
}

export async function downloadAttachment(attachmentId) {
	const { data } = await demandsAPI.post(
		`/tasks/download-attachments/${attachmentId}`
	)

	return data
}

export async function downloadMessageAttachment(demandId, messageId) {
	const { data } = await demandsAPI.get(
		`/tasks/messages/download-attachments/${demandId}/${messageId}`,
		{ responseType: 'blob' }
	)

	return data
}

export async function getDashboardData(startDate, endDate, filters = {}) {
	const cleanFilters = { ...filters }
	if (!cleanFilters.search) delete cleanFilters.search

	const { data } = await demandsAPI.get('/dashboard/list', {
		params: {
			startDate,
			endDate,
			...cleanFilters,
		},

		paramsSerializer: (params) => {
			return qs.stringify(params, { arrayFormat: 'brackets' })
		},
	})

	return data
}

export async function deleteTask(taskId) {
	const { data } = await demandsAPI.delete(`/tasks/delete/${taskId}`)

	return data
}

export async function getAnalysisObjectsOptions(page = 1, limit = 50) {
	const { data } = await demandsAPI.get(
		`/tasks/list-analysis-objects?page=${page}&limit=${limit}`
	)
	const result = formatOptions(data.list)
	return result || []
}

export async function addDemandComment(body) {
	const { data } = await demandsAPI.post(`/tasks/comment`, body)

	return data
}

export async function approveWorkflowStep(formData) {
	try {
		const response = await demandsAPI.put(`/workflow/approve`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})

		if (!response || !response.data) {
			throw new Error(
				'A API não retornou uma resposta válida ao aprovar etapa do workflow.'
			)
		}
		return response?.data
	} catch (error) {
		console.error('Erro ao aprovar etapa do workflow:', error)

		const errorMessage =
			error.response?.data?.message ||
			error.message ||
			'Erro desconhecido ao aprovar etapa do workflow.'
		throw new Error(errorMessage)
	}
}

export async function archiveWorkflow({ taskId, comments }) {
	const { data } = await demandsAPI.put(`/workflow/archive`, {
		taskId,
		comments,
	})

	return data
}

export async function rejectWorkflowStep(dody) {
	const { data } = await demandsAPI.put(`/workflow/reject`, dody)

	return data
}
